import { RECEIVE_TYPE } from "../../actionTypes.js";
/** Update state with data
 *
 * @param data
 * @param param1 { schema, key, type, updaters, dataExpiryLength }
 */

export default function createReceive(data, _ref) {
  var schema = _ref.schema,
      key = _ref.key,
      args = _ref.args,
      updaters = _ref.updaters,
      update = _ref.update,
      dataExpiryLength = _ref.dataExpiryLength;

  /* istanbul ignore next */
  if (process.env.NODE_ENV === 'development' && dataExpiryLength < 0) {
    throw new Error('Negative dataExpiryLength are not allowed.');
  }

  var now = Date.now();
  var meta = {
    schema: schema,
    key: key,
    args: args,
    date: now,
    expiresAt: now + dataExpiryLength
  };
  meta.updaters = updaters;
  meta.update = update;
  return {
    type: RECEIVE_TYPE,
    payload: data,
    meta: meta
  };
}